import React from "react";

import { visibilityStore } from "./store/VisibilityStore";
import { Container } from "../Container";
import { VisibilityMarkenShared, IProps } from "./VisibilityMarkenShared";

export const VisibilityMarkenSharedWidget = (props: IProps): JSX.Element => (
	<Container store={visibilityStore}>
		<VisibilityMarkenShared {...props} />
	</Container>
);
